import ApiRoute from '../api/ApiRoute';
import Urls from '../api/Configuration';
import LoginResponse from '../api/dtos/auth/LoginResponse';
import EmptyApiResponse from '../api/dtos/EmptyApiResponse';
import GetUsersResponse from '../api/dtos/user/GetUsersResponse';
import { RegisterRequest } from '../api/dtos/user/RegisterRequest';
import { UpdateRoleRequest } from '../api/dtos/user/UpdateRoleRequest';
import GetUserRoleResponse from '../api/dtos/user/UserRoleResponse';
import ServiceLocator from './ServiceLocator';


export default class ManagementService {

    public Register(request: RegisterRequest): Promise<LoginResponse> {
        return ServiceLocator.ApiClient.Post<LoginResponse>(Urls.ADMIN_REGISTER, request);
    }
    public GetUsers(): Promise<GetUsersResponse> {
        return ServiceLocator.ApiClient.Get<GetUsersResponse>(Urls.ADMIN_USERS);
    }

    public UpdateUserRole(userId: number, request: UpdateRoleRequest): Promise<GetUserRoleResponse> {
        return ServiceLocator.ApiClient.Patch<GetUserRoleResponse>(ApiRoute.Create(Urls.ADMIN_USER)
            .WithParameter('userId', userId)
            .AsUrl(),request
        );
    }

    public RemoveUser(userId: number): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Delete<EmptyApiResponse>(ApiRoute.Create(Urls.ADMIN_USER)
            .WithParameter('userId', userId)
            .AsUrl(), null
        );
    }
}